import { ISelectOption } from "./selectOption.interface";
import { FilterTypesEnum } from "../filters/filterTypes.enum";
import { beautifyCamelCaseString } from "src/app/common/stringUtils";
import { AgentClientApplication, AgentClientApplicationIcon } from "../api/agentStep.model";

const allClientApplications = (Array.from(Object.keys(AgentClientApplication)) as (keyof typeof AgentClientApplication)[]).map(
    (clientAppStr) => AgentClientApplication[clientAppStr],
);

export const clientApplicationSelectOptions: ISelectOption[] = allClientApplications.sort().map((clientApplication: AgentClientApplication) => ({
    id: `${FilterTypesEnum.ClientApplication}-${clientApplication}`,
    value: clientApplication,
    displayName: beautifyCamelCaseString(clientApplication),
    categoryName: FilterTypesEnum.ClientApplication.toString(),
    filterType: FilterTypesEnum.ClientApplication,
    withoutBeautifyDisplayName: true,
    iconPath: Object.values(AgentClientApplicationIcon).includes(clientApplication.toString() as AgentClientApplicationIcon)
        ? `assets/images/logo/agent-client-app-${clientApplication}.svg`
        : "assets/images/logo/agent-client-app-other.svg",
}));
